import { reactive } from 'vue'
import { reset, setFieldsErrors } from '@/helpers'

const errorStoreState = reactive({
  phoneError: '',
  emailError: '',
  nameError: '',
  placeError: '',
  displayNameError: '',
  codeError: '',
  mobileError: '',
  truckNoError: '',
  driverNoError: '',
  bannerImage: '',
  truckNo: '',
  loadingDateError: '',
})

const resetData = reactive({ ...errorStoreState })

const errorStoreActions = {
  clearErrors() {
    reset(errorStoreState, resetData)
  },

  clearFieldError(field: string) {
    errorStoreState[field] = null
  },

  handleApiError(error: any) {
    errorStoreActions.clearErrors() // Clear errors before handling new errors

    if (error.length > 0) {
      setFieldsErrors(errorStoreState, error)

      return false
    }
  },
}

export const useErrorStore = () => ({
  state: errorStoreState,
  actions: errorStoreActions,
})
